export const LANE_PIN_COLOR = '#1870eb';
export const LANE_MUTED_COLOR = '#5c5d6a';

const baseLanePinButtonStyles = {
    borderRadius: '4px',
    padding: '4px 10px',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '22px',
    letterSpacing: '0.46px',
    textTransform: 'none',
    flexShrink: 0,
    '& .MuiButton-startIcon': {
        marginRight: '8px',
        minHeight: '24px',
        display: 'flex',
        alignItems: 'center',
    },
    '& .MuiButton-startIcon svg': {
        width: '18px',
        height: '18px',
    },
};

const pinnedLanePinButtonStyles = { ...baseLanePinButtonStyles, color: LANE_PIN_COLOR, borderColor: 'rgba(78, 151, 255, 0.5)' };
const unpinnedLanePinButtonStyles = { ...baseLanePinButtonStyles, color: LANE_MUTED_COLOR, borderColor: 'rgba(100, 101, 113, 0.5)' };

export const lanePinButtonStyles = (isPinned) => (isPinned ? pinnedLanePinButtonStyles : unpinnedLanePinButtonStyles);
